/**
 * Analytics — thin wrapper around Plausible with a safe no-op fallback.
 *
 * Set REACT_APP_PLAUSIBLE_DOMAIN to the domain you registered on plausible.io
 * (e.g. "harmonixhealthapp.org"). When empty, tracking is a silent no-op
 * so preview / local dev never leaks noise into the live dashboard.
 */

const DOMAIN = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
let loaded = false;

export function loadAnalytics() {
  if (loaded) return;
  if (!DOMAIN) return;
  if (typeof window === "undefined") return;
  // Only load on the live domain so preview visits aren't counted.
  if (window.location.hostname !== DOMAIN) return;

  const s = document.createElement("script");
  s.defer = true;
  s.setAttribute("data-domain", DOMAIN);
  // outbound-links + file-downloads for free; manual events for custom goals.
  s.src = "https://plausible.io/js/script.outbound-links.file-downloads.manual.js";
  document.head.appendChild(s);

  // Enqueue a trackPageview helper that works even before the script loads.
  const scriptQueue = `window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }`;
  const q = document.createElement("script");
  q.innerHTML = scriptQueue;
  document.head.appendChild(q);

  loaded = true;
}

/**
 * track(eventName, { props, revenue })
 * - eventName: human string like "Signup" or "Pro Upgraded"
 * - props: optional dict of simple string/number properties
 * - revenue: optional { currency, amount } for conversion value
 */
export function track(eventName, options = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.plausible !== "function") return;
  try {
    window.plausible(eventName, options);
  } catch (_e) {
    // never throw from analytics
  }
}

export function pageview() {
  track("pageview");
}
